// extracted by mini-css-extract-plugin
module.exports = {"customize-bundle-for-dpu":"CustomizeBundleForSHP2_customize-bundle-for-dpu__pXugt"};